// @flow
import React from 'react';
import core from '@bravissimolabs/website-core';
import { connect } from 'react-redux';
import { renderRoutes } from '@bravissimolabs/react-router-config';

import { receiveSidebarContent } from '../../../actions/sidebar';
import { receiveCountries, apiGetCountries } from '../../../actions/countries';
import type { ApiGetCountries } from '../../../actions/system/types';

type Props = {
  fetchCountries: boolean,
  dispatch: (action: ApiGetCountries) => Promise<any>,
  route: MatchedRoute,
};

class AccountPage extends React.Component<Props> {
  /**
   * @param {Object} store
   * @returns {void}
   */
  static async populateStore(store) {
    const sidebarContent = await core.content.sidebar.getSidebarContent(
      'account',
      'details'
    );
    store.dispatch(receiveSidebarContent(sidebarContent));

    // Get the available countries we deliver to.
    const countries = await core.system.system.getCountries();
    store.dispatch(receiveCountries(countries));
  }

  /**
   * If we need to fetch countries get them from the system api.
   */
  componentDidMount() {
    if (this.props.fetchCountries) {
      this.props.dispatch(apiGetCountries());
    }
  }

  /**
   * @returns {*}
   */
  render() {
    return renderRoutes(this.props.route.routes);
  }
}

const mapStateToProps = ({ countries: { data } }) => ({
  // We should always have countries. Fetch them if they're not available
  fetchCountries: !(data && data.length),
});

export default connect(mapStateToProps)(AccountPage);
